import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { environment } from 'src/app/environments';

@Component({
  selector: 'app-view-company-profile',
  templateUrl: './view-company-profile.component.html',
  styleUrls: ['./view-company-profile.component.css']
})
export class ViewCompanyProfileComponent implements OnInit {

  id : any = false
  isLoading : boolean = false
  path : any = environment.ASSETS_URL
  card : any = false

  constructor(
    private dataService : DataService,
    private route : ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.dataService.setTitle('Company Profile | Cards')
    this.route.params.subscribe(
      (params) => {
        this.id = params['id']
        this.getCard();
      }
    )
  }

  getCard() {

    this.isLoading = true

    this.dataService.__post('/company-profile', {id: this.id})
    .subscribe(
      (success) => {
        this.isLoading = false
        this.card = success
      },
      (error) => {
        this.isLoading = false
        this.dataService.showAlert('error', 'Error', error)
      }
    )

  }

}
